// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3N4zI","requiredAsterisk":"Info_requiredAsterisk__22bWY"};